"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialInfinityIntValues = exports.INFINITY = void 0;
exports.INFINITY = "INFINITY";
exports.initialInfinityIntValues = { type: exports.INFINITY, status: "ACTIVE", data: { username: "", password: "", platformType: "560" } };
